<template>
  <div class="q-wrap">
    <div class="q-row">
      <label class="q-label">Texto de la pregunta</label>
      <input class="q-input" :class="{ 'q-input--error': question.error }" type="text"
        placeholder="Escribe la pregunta aquí..." v-model="question.texto" />
      <p v-if="question.error" class="q-error-msg">Ingrese la pregunta.</p>
    </div>

    <div class="q-row">
      <label class="q-label">Descripción <span>(opcional)</span></label>
      <textarea class="q-input" type="text" placeholder="Describe lo que se espera en la respuesta..." v-model="question.descripcion" ></textarea>
    </div>

    <div class="q-row">
      <label class="q-label">Nota <span>(opcional)</span></label>
      <input class="q-input" type="text" placeholder="Escribe una nota corta o definición..." v-model="question.nota_para_registrante" />
    </div>

    <!-- Opciones principales -->
    <div class="q-row">
      <div class="q-options-header">
        <span class="q-label m-0">Opciones de respuesta</span>
        <button type="button" class="q-add-btn" @click="addOption">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          Agregar
        </button>
        <p v-if="question.optionError" class="q-error-msg">Deben llenarse todas las opciones.</p>
        <p v-if="question.minimumError" class="q-error-msg">Minimo dos opciones.</p>
        <p v-if="question.maximumOptionError" class="q-error-msg">Maximo {{ maxOptions }} opciones.</p>

        <label class="q-check-row ml-auto">
          <input type="checkbox" v-model="question.obligatoria" />
          <span>Obligatoria</span>
        </label>
      </div>
    </div>
    <div class="q-row">

      <div class="q-options-list">
        <div v-for="(option, index) in question.opciones" :key="index" class="q-option-row">
          <span class="q-option-prefix">{{ index + 1 }}.</span>
          <input class="q-input" :class="{ 'q-input--error': option === '' && question.optionError }"
            type="text" :placeholder="'Opcion ' + (index + 1)" v-model="question.opciones[index]" />
          <button v-if="question.opciones.length > 2" type="button" class="q-remove-btn" @click="removeOption(index)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Preguntas condicionadas -->
    <div class="q-row">
      <div class="q-options-header">
        <span class="q-label m-0">Preguntas condicionadas</span>
        <button type="button" class="q-add-btn q-add-btn--teal" @click="addCondQuestion('open')">+ Abierta</button>
        <button type="button" class="q-add-btn q-add-btn--indigo" @click="addCondQuestion('multiple')">+ Opcion</button>
        <button type="button" class="q-add-btn q-add-btn--pink" @click="addCondQuestion('fields')">+ Campos</button>
        <p v-if="question.errorCond" class="q-error-msg">Debe agregar al menos una pregunta condicionada.</p>
        <p v-if="question.maximumError" class="q-error-msg">No puedes agregar mas preguntas que opciones.</p>
        <p v-if="question.duplicateError" class="q-error-msg">No repitas la misma opcion de activacion.</p>
      </div>
      <div class="q-subq-list">
        <div v-for="(pregunta_condicion, index) in question.preguntas_condicion" :key="pregunta_condicion.id" class="q-subq-item">
          <open-sub-question
            v-if="pregunta_condicion.tipo === 'ABIERTA'"
            @click="removeCondQuestion(index)" :question="pregunta_condicion"
            color="orange" :ref="'subquestion' + index"
            :parentType="question.tipo" :parentOptions="question.opciones">
          </open-sub-question>
          <multiple-sub-question
            v-if="pregunta_condicion.tipo === 'SELECCION'"
            @click="removeCondQuestion(index)" :question="pregunta_condicion"
            color="orange" :ref="'subquestion' + index"
            :parentType="question.tipo" :parentOptions="question.opciones">
          </multiple-sub-question>
          <fields-sub-question
            v-if="pregunta_condicion.tipo === 'CAMPOS'"
            @click="removeCondQuestion(index)" :question="pregunta_condicion"
            color="orange" :ref="'subquestion' + index"
            :parentType="question.tipo" :parentOptions="question.opciones">
          </fields-sub-question>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultipleSubQuestion from "./MultipleSubQuestion.vue";
import OpenSubQuestion from "./OpenSubQuestion.vue";
import FieldsSubQuestion from "./FieldsSubQuestion.vue";

export default {
  name: "conditional-question",
  data() { return { lastId: 1, maxOptions: 25 }; },
  components: { OpenSubQuestion, MultipleSubQuestion, FieldsSubQuestion },
  mounted() {
    this.lastId = this.question.preguntas_condicion.length + 1;
    this.fetchConfiguration();
  },
  methods: {
    fetchConfiguration() {
      this.axios.get("apidev/api/config/site").then(response => {
        if (response.data && response.data.config && typeof response.data.config.max_question_options === "number") {
          this.maxOptions = response.data.config.max_question_options;
        }
      }).catch(() => {});
    },
    remove() { this.$emit("click"); },
    addCondQuestion(type) {
      this.lastId = this.question.preguntas_condicion.length? this.question.preguntas_condicion.length + 1 : 1;
      if (this.question.preguntas_condicion.length < this.question.opciones.length) {
        let base = { id: this.question.numero_pregunta + "." + this.lastId, numero_pregunta: this.question.numero_pregunta + ".1", texto: "", nota_para_registrante: "", error: false, assignment: "", assignmentError: false };
        if (type === "open") this.question.preguntas_condicion.push({ ...base, tipo: "ABIERTA" });
        if (type === "multiple") this.question.preguntas_condicion.push({ ...base, tipo: "SELECCION", opciones: ["", ""], optionError: false, minimumError: false, maximumOptionError: false });
        if (type === "fields") this.question.preguntas_condicion.push({ ...base, tipo: "CAMPOS", campos: [{ texto: "", tipo: "texto" }], fieldError: false, minimumError: false });

      } else { this.question.maximumError = true; }
    },
    removeCondQuestion(idx) {
      this.question.preguntas_condicion.splice(idx, 1);
      this.question.preguntas_condicion.forEach((q, i) => { q.id = this.question.numero_pregunta + "." + (i + 1); });
      this.lastId = this.question.preguntas_condicion.length + 1;
      this.question.maximumError = false;
    },
    addOption() {
      if (this.question.opciones.length < this.maxOptions) { this.question.opciones.push(""); this.question.minimumError = false; }
      else { this.question.maximumOptionError = true; }
    },
    removeOption(index) {
      if (this.question.opciones.length > 2) {
        const opt = this.question.opciones[index];
        const cq = this.question.preguntas_condicion.find(q => q.assignment === opt);
        if (cq) cq.assignment = "";
        this.question.opciones.splice(index, 1);
        this.question.minimumError = false; this.question.maximumOptionError = false;
      } else { this.question.minimumError = true; }
    },
    validateQuestion() {
      this.question.minimumError = false;
      return this.validateEmptyQuestion() & this.validateOptions() & this.validateCondQuestions() & this.validateSubquestions() & this.validateAssignments();
    },
    validateEmptyQuestion() {
      if (this.question.texto === "") { this.question.error = true; return false; }
      this.question.error = false; return true;
    },
    validateOptions() {
      const empty = this.question.opciones.filter(o => o === "");
      if (empty.length > 0) { this.question.optionError = true; return false; }
      this.question.optionError = false; return true;
    },
    validateCondQuestions() {
      if (this.question.preguntas_condicion.length === 0) { this.question.errorCond = true; return false; }
      this.question.errorCond = false; return true;
    },
    validateSubquestions() {
      if (this.question.preguntas_condicion.length > 0) {
        let vals = [];
        Object.keys(this.$refs).forEach(el => { if (this.$refs[el][0]) vals.push(this.$refs[el][0].validateQuestion()); });
        return vals.every(Boolean);
      }
      return true;
    },
    validateAssignments() {
      if (this.question.preguntas_condicion.length > 0) {
        let assignments = [];
        Object.keys(this.$refs).forEach(el => { if (this.$refs[el][0]) assignments.push(this.$refs[el][0].question.assignment); });
        if (new Set(assignments).size !== assignments.length) { this.question.duplicateError = true; return false; }
        this.question.duplicateError = false; return true;
      }
      return true;
    },
  },
  props: { question: { required: true } },
};
</script>

<style scoped>
.q-wrap { display: flex; flex-direction: column; gap: 12px; font-size: 0.82rem; }
.q-row { display: flex; flex-direction: column; gap: 4px; }
.q-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #64748b; }
.q-input { width: 100%; padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 7px; background: #f8fafc; color: #334155; font-size: 0.82rem; transition: border-color 0.15s; outline: none; box-sizing: border-box; }
.q-input:focus { border-color: #f97316; box-shadow: 0 0 0 3px rgba(249,115,22,0.12); background: #fff; }
.q-input--error { border-color: #f87171 !important; }
.q-error-msg { font-size: 0.7rem; color: #ef4444; margin: 0; }
.q-check-row { display: flex; align-items: center; gap: 6px; }
.q-check-row input[type=checkbox] { width: 14px; height: 14px; accent-color: #f97316; cursor: pointer; }
.q-check-row span { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: #475569; }
.q-options-header { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.q-add-btn { display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; border: 1px solid #e2e8f0; border-radius: 6px; background: #f1f5f9; color: #475569; font-size: 0.72rem; font-weight: 600; cursor: pointer; }
.q-add-btn--teal { background: #ccfbf1; color: #0d9488; border-color: #99f6e4; }
.q-add-btn--indigo { background: #e0e7ff; color: #6366f1; border-color: #c7d2fe; }
.q-add-btn--pink { background: #fce7f3; color: #ec4899; border-color: #f9a8d4; }
.q-add-btn svg { width: 12px; height: 12px; }
.q-options-list { display: flex; flex-direction: column; gap: 5px; }
.q-option-row { display: flex; align-items: center; gap: 6px; }
.q-option-prefix { font-size: 0.72rem; color: #94a3b8; min-width: 18px; text-align: right; flex-shrink: 0; }
.q-remove-btn { display: flex; align-items: center; justify-content: center; width: 22px; height: 22px; border: 1px solid #fca5a5; border-radius: 5px; background: #fef2f2; color: #ef4444; cursor: pointer; flex-shrink: 0; }
.q-remove-btn svg { width: 12px; height: 12px; }
.q-subq-list { display: flex; flex-direction: column; gap: 8px; }
.q-subq-item { background: #fff7ed; border: 1px solid #fed7aa; border-radius: 8px; padding: 12px; }
</style>
